// src/pages/ResetPasswordPage.jsx
import React, { useMemo, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import "../css/LoginPage.css";

const API_BASE = process.env.REACT_APP_API_BASE_URL;

export default function ResetPasswordPage() {
    const [sp] = useSearchParams();
    const token = useMemo(() => sp.get("token") || "", [sp]);
    const [pwd, setPwd] = useState("");
    const [pwd2, setPwd2] = useState("");
    const [loading, setLoading] = useState(false);
    const [done, setDone] = useState(false);
    const [error, setError] = useState("");
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (loading) return;
        setError("");

        if (!token) return setError("Token mancante o non valido");
        if (!pwd || pwd.length < 8)
            return setError("La password deve avere almeno 8 caratteri");
        if (pwd !== pwd2) return setError("Le password non coincidono");

        try {
            setLoading(true);
            const res = await fetch(`${API_BASE}/api/auth/reset-password`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ token, new_password: pwd }),
            });
            const data = await res.json().catch(() => ({}));
            if (!res.ok)
                return setError(
                    data.error || "Impossibile reimpostare la password"
                );
            setDone(true);
        } catch {
            setError("Errore di rete");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="login-page">
            <div className="login-topbar">
                <div className="login-topbar-inner">
                    <img
                        src="/logo.png"
                        alt="StirUp logo"
                        className="login-logo"
                        width={64}
                        height={64}
                    />
                    <h1 className="login-topbar-title">
                        STIRUP: PIATTAFORMA DI STIRO CON RITIRO E CONSEGNA A DOMICILIO
                    </h1>
                </div>
            </div>

            <div className="login-hero">
                <div className="login-hero-inner">
                    <form className="login-card" onSubmit={handleSubmit} noValidate>
                        <h2 className="login-card-title">Imposta nuova password</h2>
                        <p className="login-card-subtitle">
                            Scegli una nuova password per il tuo account.
                        </p>

                        <div className="login-fields-frame">
                            {!done ? (
                                <>
                                    {!token && (
                                        <div className="login-error-box" role="alert">
                                            Token mancante o non valido.
                                        </div>
                                    )}

                                    {token && (
                                        <>
                                            <div className="login-field">
                                                <label htmlFor="pwd" className="login-label">
                                                    Nuova password *
                                                </label>
                                                <input
                                                    id="pwd"
                                                    type="password"
                                                    value={pwd}
                                                    onChange={(e) => setPwd(e.target.value)}
                                                    required
                                                    autoComplete="new-password"
                                                    className="input login-input"
                                                />
                                                <span className="hint">Minimo 8 caratteri.</span>
                                            </div>
                                            <div className="login-field">
                                                <label htmlFor="pwd2" className="login-label">
                                                    Conferma password *
                                                </label>
                                                <input
                                                    id="pwd2"
                                                    type="password"
                                                    value={pwd2}
                                                    onChange={(e) => setPwd2(e.target.value)}
                                                    required
                                                    autoComplete="new-password"
                                                    className="input login-input"
                                                />
                                            </div>

                                            <div className="login-actions">
                                                <button
                                                    type="submit"
                                                    disabled={loading || !token}
                                                    aria-busy={loading}
                                                    className="btn login-btn-outline"
                                                >
                                                    {loading ? "Salvataggio…" : "Salva password"}
                                                </button>
                                            </div>
                                        </>
                                    )}

                                    {error && (
                                        <div className="login-error-box" role="alert">
                                            {error}
                                        </div>
                                    )}
                                </>
                            ) : (
                                <>
                                    <div
                                        style={{
                                            textAlign: "center",
                                            margin: "6px 0 8px",
                                            fontSize: 22,
                                        }}
                                    >
                                        ✅
                                    </div>
                                    <p
                                        style={{
                                            margin: "6px 0 0",
                                            fontSize: 16,
                                            color: "#222",
                                            textAlign: "center",
                                        }}
                                    >
                                        Password aggiornata correttamente.
                                    </p>
                                    <div className="login-actions">
                                        <button
                                            type="button"
                                            onClick={() => navigate("/login")}
                                            className="btn login-btn-outline"
                                        >
                                            Vai al login
                                        </button>
                                    </div>
                                </>
                            )}
                        </div>
                    </form>
                </div>
            </div>

            <footer className="login-footer">
                <p className="login-payoff">
                    Stirup: piattaforma di stiro con ritiro e consegna a domicilio
                </p>
            </footer>
        </div>
    );
}
